import { getFormProps, useForm } from "@conform-to/react";
import { parseWithZod } from "@conform-to/zod";
import { Block, Button, f7, Icon, List, ListInput } from "framework7-react";

import { passwordResetRequestBody, usePasswordResetRequest } from "@/generated/api";

type PasswordResetRequestFormProps = {
  redirectUrl: string;
  onCompleted: VoidFunction;
};

export function PasswordResetRequestForm({ redirectUrl, onCompleted }: PasswordResetRequestFormProps) {
  const { mutate, isPending } = usePasswordResetRequest();

  const [form, fields] = useForm({
    defaultValue: {
      email: "",
      redirect_url: redirectUrl,
    },
    onSubmit(event, { formData }) {
      event.preventDefault();

      const submission = parseWithZod(formData, { schema: passwordResetRequestBody });

      if (submission.status !== "success") {
        return submission.reply();
      }

      mutate(
        { data: submission.value },
        {
          onError: () => {
            f7.toast.create({
              closeTimeout: 2000,
              text: "再設定メールの送信に失敗しました",
            });
          },
          onSuccess: () => {
            onCompleted();
          },
        },
      );
    },
    onValidate({ formData }) {
      return parseWithZod(formData, { schema: passwordResetRequestBody });
    },
    shouldValidate: "onBlur",
  });

  return (
    <form {...getFormProps(form)}>
      <input
        defaultValue={redirectUrl}
        name={fields.redirect_url.name}
        type="hidden"
      />
      <List>
        <ListInput
          clearButton
          floatingLabel
          required
          validate
          autocomplete="email"
          errorMessage={fields.email.errors?.join("\n")}
          info="メールアドレスを入力してください"
          label="メールアドレス"
          name={fields.email.name}
          placeholder="user@timefill.me"
          type="email"
        >
          <Icon
            material="email"
            slot="media"
          />
        </ListInput>
      </List>
      <Block>
        <Button
          fill
          large
          loading={isPending}
          type="submit"
        >
          再設定メール送信
        </Button>
      </Block>
    </form>
  );
}
